package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_08_01_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in their bastion in Freeburg. They are concerned about Bigglesworth’s new friend, Razorwrath, the sentient Vorpal sword. Tuesday and Falorn examine the blade closely. The runes spell out the blade’s name in Abyssal.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Razorwrath thinks Tuesday is annoying. He likes magic.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday casts the Light cantrip on Razorwrath, causing it to glow red. Bigglesworth drops the sword on the floor.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette suggests inviting Lord Fox to the bastion for dinner. Given Fox’s background as an adventurer and collector, perhaps he would have some advice about the powerful blade. Stadler sends a runner to invite Lord Fox to dinner tomorrow night.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dirk announces that Goram will be teleporting to Freeburg tomorrow.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes start walking to Wharf-side Wicket Inn to receive an update from Prudence on the Barrowmen’s investigation of Lord Pent.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth notices that the glowing red sword is now at his side. How did it get there? He left it on the floor in the bastion. He slows his pace and looks exhausted. Falorn and Caper are concerned. Bigglesworth repeats that the sword is hungry. Falorn casts Greater Restoration on Bigglesworth. Bigglesworth feels better.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When they arrive at the Inn, Tuesday sasses a guard, and they have a brief quarrel. Tuesday and Caper plan to prank the guard that slighted Tuesday. Tuesday fills in Prudence on the adventure. Annette asks for a status report.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Lord Pend left Dorvid and returned to his estate, traveling via magic, but probably not via the teleportation rings controlled by the Dravidian empire because the military has closed them down? Lord Pent has amassed a large retinue of soldiers who follow his orders rather than the Dorvidian Emperor’s orders. The Dorvidian-Freeburg border has increased security/guards. Lord Pent’s estate is a castle set among cliffs. An underground path directly to the ocean.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette asks if Prudence smuggles across the border. She does but wouldn't say how. Trade secret. She does clarify that she isn't a human trafficker.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to the bastion. Lord Fox accepted their invitation.")
    }
}
